export default {
  url: '',
  // apiUrl: process.env.NODE_ENV == 'production' ? 'http://52.35.196.90:8080/api': 'http://localhost:3000/api'
   apiUrl: process.env.NODE_ENV == 'production' ? '/api': 'http://localhost:4000/api'
  //apiUrl: process.env.NODE_ENV == 'production' ? '/api': 'https://new.medicentric.com/api'
}


// WEBPACK FOOTER //
// ./client/config.js